import { useApolloClient } from "@apollo/client";
import styled from "@emotion/styled";
import InputWithIcon from "@mostrans/web-components/components/advanced/Input/InputWithIcon";
import Button from "@mostrans/web-components/components/base/Button";
import Checkbox from "@mostrans/web-components/components/base/Checkbox";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import { CircularProgress, Dialog, Icon } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useSetState } from "react-use";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { headerImage, imageHeroMostrans } from "../../../assets";
import ResendOTP from "../../../components/Form/ResendOTP";
import Navbar from "../../../components/Home/Navbar";
import { loginCandidate } from "../../../graphql/mutations";
import {
  authTokenAtom,
  globalLoadingAtom,
  globalModalOpenAtom
} from "../../../shared/globalStates";
import { addToken } from "../../../shared/helpers";



const LoginContainer = styled.div`
    display: grid;
    height: 100vh;
    overflow-x: hidden;
    grid-template-columns: 1fr 1fr;
    .animated-image {
      @keyframes slideUpAnimation {
        0% {
          opacity: 0;
          transform: translate3d(0, 100%, 0);
        }
        100% {
          opacity: 1;
          transform: translate3d(0, 0, 0);
        }
      }
      animation: slideUpAnimation 3s forwards;  
    }
    .image-container {
        display: grid;
        place-items: center;
        background-image: url("${headerImage}");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        img {
            width: 50%;
        }
    }
    .login-content {
        display: grid;
        padding: 2rem 1rem;
        place-items: center;
    }
    .login-form {
        display: flex;
        flex-direction: column;
        width: 75%;
        gap: 1rem;
        img {
            width: 75%;
            margin: auto;
            display: none;
        }
    }
    ${(p) => p.theme.breakpoints.down("sm")} {
        grid-template-columns: 1fr;
        .image-container {
            display: none;
        }
        .login-form {
            img {
                display: block;
            }
        }
    }
`;



function Login() {
  const [inputData, setInputData] = useSetState({
    email: "",
    password: "",
    rememberMe: true,
  });
  const [errMsg, setErrMsg] = useState("");
  const setLoading = useSetRecoilState(globalLoadingAtom);
  const setToken = useSetRecoilState(authTokenAtom);
  const loading = useRecoilValue(globalLoadingAtom);
  const history = useHistory();
  const [open, setOpen] = useRecoilState(globalModalOpenAtom);
  const [title, setTitle] = useState("");
  const [showPass, setShowPass] = useState(false);

  const client = useApolloClient();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputData.email || !inputData.password) {
      setErrMsg("Email dan password tidak boleh kosong");
    } else {
      setLoading(true);
      const err = await loginCandidate(client, inputData);
      setLoading(false);
      if (err.response.status !== "000") {
        setErrMsg("Email atau password salah!");
      } else {
        addToken(err.token);
        setToken(err.token);
        history.push("/career/home");
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          position: "fixed !important",
          textAlign: "center !important",
          justifyContent: "center !important",
          top: "0 !important",
          bottom: " 0 !important",
          right: "0 !important",
          left: "0 !important",
          width: "100% !important",
          height: "100% !important",
          display: loading ? "flex !important" : "none !important",
          alignItems: "center !important",
          backgroundColor: "#00000087 !important",
          zIndex: " 99999",
        }}
      >
        <CircularProgress />
      </Box>

      <Dialog open={open} onClose={handleClose}>
        <ResendOTP setOpens={setOpen} handleClose={handleClose} title={title} />
      </Dialog>

      <Navbar />
      <LoginContainer>
        <div className="image-container">
          <div className="d-flex flex-column gap-1">
            <div className="d-flex flex-column justify-content-center">
              <h3>Login</h3>
              <h1 className="text-primary-main type-animated">Mostrans Career</h1>
            </div>
            <div className="d-flex">
              <img
                className="animated-image"
                style={{ width: 400, height: "auto", marginBottom: "-9rem" }}
                src={imageHeroMostrans} alt="logo mostrans"
              />
            </div>
          </div>
        </div>
        <div className="login-content bg-white">
          <form className="login-form">
            {/* <img src={logoMostransV2} alt="logo mostrans" /> */}
            <h3 className="mb-1">Login</h3>
            <FormGroup
              label="Email">
              <Input
                placeholder="Email"
                autoFocus
                onChange={(e) => setInputData({ email: e.target.value })}
                value={inputData.email}
                required
                type="text"
                name="email"
              />
            </FormGroup>

            <FormGroup
              label="Password">
              <InputWithIcon
                onEndIconClick={() =>
                  setShowPass((p) => !p)
                }
                endIcon={
                  <Icon>
                    {showPass
                      ? "visibility_off"
                      : "visibility_on"}
                  </Icon>
                }
                onChange={(e) =>
                  setInputData({
                    password: e.target.value,
                  })
                }
                value={inputData.password}
                required
                type={showPass ? "text" : "password"}
                name="password"
                placeholder="Password"
              />
            </FormGroup>
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex gap-1">
                <Checkbox
                  color="primary"
                  onChange={(e) =>
                    setInputData({
                      rememberMe: e.target.checked,
                    })
                  }
                  checked={inputData.rememberMe}
                  className="p-0"
                  type="checkbox"
                  id="remember-me"
                />
                <p>Remember me</p>
              </div>
              <div className="d-flex flex-column">
                <p
                  className="font-size-small text-textSecondary text-right text-primary-main-hover"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setOpen(true);
                    setTitle("Forgot Password");
                  }}
                >
                  Forgot Password
                </p>
                <p
                  className="font-size-small text-textSecondary text-right text-primary-main-hover"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setOpen(true);
                    setTitle("Resend OTP");
                  }}
                >
                  Resend OTP
                </p>
              </div>
            </div>
            <div className="d-flex">
              <p
                className="text-danger"
                style={{
                  fontSize: "0.8rem",
                  fontWeight: "bold",
                }}
              >
                {errMsg}
              </p>
            </div>
            <Button
              onClick={handleSubmit}
              type="submit"
              variant="contained"
              className="mt-2"
              color="primary"
            >
              Login
            </Button>
          </form>
        </div>
      </LoginContainer>


      {/* <div
        className="p-2"
        style={{
          backgroundColor: "var(--ijo-mostrans)",
          height: "100vh",
          display: "grid",
          placeItems: "center",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            overflow: "hidden",
          }}
        >
          <img
            src={background}
            loading="lazy"
            alt="peta"
            style={{
              objectFit: "cover",
              height: "100%",
              width: "100%",
            }}
          />
        </div>
        <div
          className="bg-white p-3 shadow-lg"
          style={{
            display: "grid",
            zIndex: "300",
            position: "relative",
            gridTemplateColumns: "0.9fr 1.1fr",
            maxWidth: "min(100vw,850px)",
            gap: "2rem",
            borderRadius: "2px",
          }}
        >
          <div className="flex-grow-1">
            <img style={{ width: "100%" }} src={logo} alt="logo mostrans" />
          </div>
          <div className="flex-grow-1 ml-3 d-flex flex-column ">
            <h3 className="mb-3 mt-2 w-100 text-center">
              MOSTRANS Career Login
            </h3>
            <form>
              <div className="form-group ">
                <label className="form-label font-size-main">Email</label>
                <input
                  autoFocus
                  onChange={(e) => setInputData({ email: e.target.value })}
                  value={inputData.email}
                    required
                    type="text"
                    name="email"
                  className="form-control"
                  placeholder="Email"
                />
              </div>
              <div className="form-group" style={{ position: "relative" }}>
                <label className="form-label font-size-main">Password</label>
                <input
                  onChange={(e) =>
                    setInputData({
                      password: e.target.value,
                    })
                  }
                  value={inputData.password}
                  required
                  type={showPass ? "text" : "password"}
                  name="password"
                  className="form-control"
                  placeholder="Password"
                />
                <span
                  className="material-icons-outlined font-weight-w400"
                  style={{
                    position: "absolute",
                    cursor: "pointer",
                    width: "20px",
                    right: "10px",
                    bottom: "6px",
                    "&:hover": {
                      backgroundColor: "white",
                    },
                  }}
                  onClick={() => setShowPass(!showPass)}
                >
                  {showPass ? "visibility_off" : "visibility"}
                </span>
              </div>
              <div className="form-group form-check ml-0 p-0">
                <div className="row">
                  <div className="col-md-1">
                    <Checkbox
                      color="primary"
                      onChange={(e) =>
                        setInputData({
                          rememberMe: e.target.checked,
                        })
                      }
                      checked={inputData.rememberMe}
                      className="p-0"
                      type="checkbox"
                      id="remember-me"
                    />
                  </div>
                  <div className="col-md-6">
                    <label
                      style={{ marginLeft: "5px" }}
                      className="form-check-label font-size-main"
                      htmlFor="remember-me"
                    >
                      Remember me
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="form-group justify-content-end w-100 pointer"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setOpen(true);
                }}
              >
                <p
                  className="font-size-small text-textSecondary text-right text-primary-main-hover"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setOpen(true);
                    setTitle("Forgot Password");
                  }}
                >
                  Forgot Password
                </p>
                <p
                  className="font-size-small text-textSecondary text-right text-primary-main-hover"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setOpen(true);
                    setTitle("Resend OTP");
                  }}
                >
                  Resend OTP
                </p>
              </div>
              <div
                style={{
                  minHeight: "30px",
                }}
                className="form-group d-flex justify-content-center w-100"
              >
                <p
                  className="text-danger"
                  style={{
                    fontSize: "0.8rem",
                    fontWeight: "bold",
                  }}
                >
                  {errMsg}
                </p>
              </div>
              <button
                className="w-100 btn text-white d-flex justify-content-between align-items-center"
                type="submit"
                onClick={handleSubmit}
                style={{ background: "#008c45" }}
              >
                <span className="flex-grow-1">Login</span>
                <Icon style={{ fontSize: "1em" }}>arrow_forward</Icon>
              </button>
            </form>
          </div>
        </div>
      </div> */}
    </React.Fragment>
  );
}

export default React.memo(Login);
